import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKahootComponent } from './simple-icons-kahoot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKahootComponent ],
    exports:      [ SimpleIconsKahootComponent ],
    bootstrap:    []
})
export class SimpleIconsKahootModule {}
